import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Hat mir buchstäblich das Leben gerettet. Ich gab 15 Stunden pro Woche und kam mit der Planung nicht mehr hinterher. Jetzt öffne ich den Band, lese 5 Minuten und habe eine wunderschöne Stunde fertig.',
    initials: 'LK',
    name: 'Lena K.',
    location: 'Berlin 🇩🇪'
  }, {
    quote: 'Am besten gefallen mir die philosophischen Themen. Ich tat mich immer schwer, sie einzubauen, ohne langweilig zu klingen. Jetzt sagen meine Schülerinnen, dass die Stunden viel mehr Tiefe haben.',
    initials: 'SM',
    name: 'Sophie M.',
    location: 'Köln 🇩🇪'
  }, {
    quote: 'Das Modul Therapeutisches Yoga ist Gold wert. Ich war sehr unsicher, wenn Schülerinnen mit Rückenschmerzen kamen, jetzt habe ich klare Protokolle, um sie sicher zu begleiten.',
    initials: 'CB',
    name: 'Clara B.',
    location: 'Hamburg 🇩🇪'
  }, {
    quote: 'Für 19 € ist es ein Geschenk. Allein der Jahres-Tracker und die Instagram-Captions haben mir Stunden an Arbeit gespart. Sehr zu empfehlen für Lehrerinnen, die gerade anfangen.',
    initials: 'ML',
    name: 'Marie L.',
    location: 'Frankfurt 🇩🇪'
  }, {
    quote: 'Die Sequenzen sind super fließend und logisch. Meine Schülerinnen haben den Unterschied sofort bemerkt.',
    initials: 'AS',
    name: 'Anna S.',
    location: 'München 🇩🇪'
  }];
  return <section className="bg-white px-4 py-20" data-id="element-151">
      <div className="mx-auto max-w-6xl" data-id="element-152">
        <div className="mb-16 text-center" data-id="element-153">
          <h2 className="mb-4 text-3xl font-black text-brand-text md:text-4xl" data-id="element-154">
            Was die Yogalehrerinnen aus Deutschland sagen.
          </h2>
          <div className="flex flex-wrap items-center justify-center gap-2 font-medium text-brand-gray" data-id="element-155">
            <div className="flex gap-0.5" aria-label="5 von 5 Sternen" data-id="element-156">
              {Array.from({
              length: 5
            }).map((_, index) => <Star key={index} className="h-5 w-5 fill-yellow-400 text-yellow-400" aria-hidden="true" data-id="element-157" />)}
            </div>
            <span data-id="element-158">4.9/5 &middot; +1.200 Lehrerinnen</span>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-159">
          {testimonials.map(testimonial => <article key={testimonial.name} className="flex h-full flex-col rounded-3xl border border-brand-creamDark bg-[#EDE5D8] p-8" data-id="element-160">
              <div className="mb-6 flex gap-0.5" aria-label="5 von 5 Sternen" data-id="element-161">
                {Array.from({
              length: 5
            }).map((_, index) => <Star key={index} className="h-4 w-4 fill-yellow-400 text-yellow-400" aria-hidden="true" data-id="element-162" />)}
              </div>
              <p className="mb-8 flex-1 font-medium leading-relaxed text-brand-text" data-id="element-163">
                „{testimonial.quote}“
              </p>
              <div className="flex items-center gap-4" data-id="element-164">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-green text-sm font-bold text-white" data-id="element-165">
                  {testimonial.initials}
                </div>
                <div data-id="element-166">
                  <p className="text-sm font-bold text-brand-text" data-id="element-167">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-brand-gray" data-id="element-168">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}